import { updateInboxTabs } from '../actions/updateInboxTabs';
import { mutator } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';

mutator(updateInboxTabs, actionMessage => {
    getUserConfiguration().UserOptions.InboxPlusTabs = actionMessage.tabsToWrite;
});
